import { http } from '@/core/helpers/http.helper';
import { Module } from './module.interface';

export class ModuleService {
   async getModules(): Promise<Array<Module>> {
      const response = await http.get<Array<Module>>(`/modules`);
      return response.data;
   }
}
